import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import logo from "../assets/logo.png";

const generateClientStatement = ({
  client,
  invoices = [],
  payments = [],
}) => {

  // =====================================================
  // LETTER SIZE PDF
  // =====================================================

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "letter",
  });

  // =====================================================
  // COLORS
  // =====================================================

  const PRIMARY = [0, 143, 132];
  const PRIMARY_DARK = [0, 110, 101];

  const BG = [243, 246, 246];

  const WHITE = [255, 255, 255];

  const DARK = [24, 34, 48];

  const MUTED = [113, 122, 136];

  const GOLD = [255, 193, 59];

  const BORDER = [225, 231, 231];

  // =====================================================
  // TOTALS
  // =====================================================

  const invoiceTotal =
    invoices.reduce(
      (sum, inv) =>
        sum + Number(inv.amount || 0),
      0
    );

  const paymentTotal =
    payments.reduce(
      (sum, p) =>
        sum + Number(p.amount || 0),
      0
    );

  const outstandingTotal =
    invoiceTotal - paymentTotal;

  const creditBalance =
    Number(
      client.credit_balance || 0
    );

  // =====================================================
  // PAGE BG
  // =====================================================

  doc.setFillColor(
    BG[0],
    BG[1],
    BG[2]
  );

  doc.rect(
    0,
    0,
    216,
    279,
    "F"
  );

  // =====================================================
  // MAIN HEADER CARD
  // =====================================================

  doc.setFillColor(
    WHITE[0],
    WHITE[1],
    WHITE[2]
  );

  doc.roundedRect(
    10,
    10,
    196,
    58,
    10,
    10,
    "F"
  );

  // =====================================================
  // TOP RIGHT ACCENT
  // =====================================================

  doc.setFillColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.triangle(
    183,
    10,
    206,
    10,
    206,
    22,
    "F"
  );

  // =====================================================
  // LOGO BG
  // =====================================================

  doc.setFillColor(250);

  doc.circle(
    40,
    36,
    18,
    "F"
  );

  // =====================================================
  // LOGO
  // =====================================================

  try {

doc.addImage(
  logo,
  "PNG",
  24,
  20,
  30,
  30
);

  } catch (err) {

    console.error(err);
  }

  // =====================================================
  // DIVIDER
  // =====================================================

  doc.setDrawColor(
    BORDER[0],
    BORDER[1],
    BORDER[2]
  );

  doc.setLineWidth(0.5);

  doc.line(
    73,
    18,
    73,
    52
  );

  // =====================================================
  // COMPANY NAME
  // =====================================================

  doc.setTextColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(14);

  doc.text(
    "RCS TOPUP & BILLING ENTITY",
    82,
    24
  );

  // =====================================================
  // COMPANY DETAILS
  // =====================================================

  doc.setTextColor(
    DARK[0],
    DARK[1],
    DARK[2]
  );

  doc.setFont(
    "helvetica",
    "normal"
  );

  doc.setFontSize(10);

  doc.text(
    "22 BELLE PLAINE WAKENAAM",
    84,
    33
  );

  doc.text(
    "592-662-7987",
    84,
    41
  );

  doc.text(
    "www.rcsgy.com",
    84,
    49
  );

  doc.text(
    "||",
    120,
    49
  );

  doc.text(
    "rcs@rcsgy.com",
    128,
    49
  );

  // =====================================================
  // DEBT TAG
  // =====================================================

  doc.setFillColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.roundedRect(
    82,
    53,
    58,
    10,
    5,
    5,
    "F"
  );

  doc.setTextColor(255);

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(9);

  doc.text(
    "Debt Control management",
    92,
    59
  );

  // =====================================================
  // TITLE
  // =====================================================

doc.setTextColor(
  DARK[0],
  DARK[1],
  DARK[2]
);

doc.setFont(
  "helvetica",
  "bold"
);

doc.setFontSize(11);

doc.text(
  "ACCOUNT STATEMENT",
  146,
  31
);

// underline

doc.setDrawColor(
  PRIMARY[0],
  PRIMARY[1],
  PRIMARY[2]
);

doc.setLineWidth(0.4);

doc.line(
  146,
  34,
  192,
  34
);

// dot

doc.circle(
  195,
  34,
  0.6,
  "F"
);

  // =====================================================
  // DATE CARD
  // =====================================================

  doc.setFillColor(
    WHITE[0],
    WHITE[1],
    WHITE[2]
  );

  doc.roundedRect(
    160,
    46,
    38,
    18,
    5,
    5,
    "F"
  );

  doc.setFillColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.circle(
    168,
    51,
    5,
    "F"
  );

  doc.setTextColor(255);

  doc.setFontSize(5);

  doc.text(
    "DATE",
    165.5,
    52
  );

  doc.setTextColor(
    MUTED[0],
    MUTED[1],
    MUTED[2]
  );

  doc.setFontSize(7);

  doc.text(
    "STATEMENT DATE",
    177,
    48
  );

  doc.setTextColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.setFontSize(12);

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.text(
    new Date().toLocaleDateString(),
    177,
    55
  );

  // =====================================================
  // CLIENT CARD
  // =====================================================

  doc.setFillColor(
    WHITE[0],
    WHITE[1],
    WHITE[2]
  );

  doc.roundedRect(
    14,
    74,
    188,
    58,
    10,
    10,
    "F"
  );

  // =====================================================
  // AVATAR OUTER
  // =====================================================

  doc.setFillColor(230);

  doc.circle(
    40,
    103,
    18,
    "F"
  );

  // =====================================================
  // AVATAR INNER
  // =====================================================

  doc.setFillColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.circle(
    40,
    103,
    13,
    "F"
  );

  // =====================================================
  // INITIAL
  // =====================================================

  doc.setTextColor(255);

  doc.setFontSize(26);

  doc.setFont(
    "helvetica",
    "bold"
  );

const initial =
  client.name
    ?.charAt(0)
    ?.toUpperCase() || "C";

doc.setTextColor(255);

doc.setFontSize(20);

doc.setFont(
  "helvetica",
  "bold"
);

const textWidth =
  doc.getTextWidth(initial);

doc.text(
  initial,
  40 - textWidth / 2,
  105
);

  // =====================================================
  // CLIENT INFO TAG
  // =====================================================

  doc.setFillColor(240);

  doc.roundedRect(
    65,
    90,
    48,
    9,
    5,
    5,
    "F"
  );

  doc.setTextColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.setFontSize(8);

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.text(
    "CLIENT INFORMATION",
    73,
    96
  );

  // =====================================================
  // CLIENT NAME
  // =====================================================

  doc.setTextColor(
    DARK[0],
    DARK[1],
    DARK[2]
  );

  doc.setFontSize(15);

  doc.text(
    client.name || "Unknown",
    65,
    113
  );

  // =====================================================
  // SUBTEXT
  // =====================================================

  doc.setTextColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.setFontSize(12);

  doc.setFont(
    "helvetica",
    "normal"
  );

  doc.text(
    "Client",
    65,
    122
  );

  // =====================================================
  // CENTER DIVIDER
  // =====================================================

  doc.setDrawColor(
    BORDER[0],
    BORDER[1],
    BORDER[2]
  );

  doc.line(
    118,
    86,
    118,
    122
  );

  // =====================================================
  // CONTACT CARDS
  // =====================================================

  const infoX = 128;

  const drawInfoCard = (
    y,
    label,
    value,
    tag
  ) => {

    doc.setFillColor(240);

    doc.roundedRect(
      infoX,
      y,
      9,
      9,
      3,
      3,
      "F"
    );

    doc.setTextColor(
      PRIMARY[0],
      PRIMARY[1],
      PRIMARY[2]
    );

    doc.setFontSize(6);

    doc.text(
      tag,
      infoX + 1.3,
      y + 5.8
    );

    doc.setFontSize(8);

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.text(
      label,
      infoX + 14,
      y + 4
    );

    doc.setTextColor(
      DARK[0],
      DARK[1],
      DARK[2]
    );

    doc.setFontSize(11);

    doc.setFont(
      "helvetica",
      "normal"
    );

    doc.text(
      value || "—",
      infoX + 14,
      y + 12
    );
  };

  drawInfoCard(
    88,
    "ADDRESS",
    client.address,
    "ADR"
  );

  drawInfoCard(
    103,
    "PHONE",
    client.phone,
    "TEL"
  );

  drawInfoCard(
    118,
    "EMAIL",
    client.email,
    "MAIL"
  );

  // =====================================================
  // KPI STRIP
  // =====================================================

  doc.setFillColor(
    PRIMARY_DARK[0],
    PRIMARY_DARK[1],
    PRIMARY_DARK[2]
  );

  doc.roundedRect(
    14,
    142,
    188,
    28,
    6,
    6,
    "F"
  );

  const kpis = [
    {
      label: "TOTAL INVOICED",
      value: invoiceTotal,
      x: 28,
      color: [255, 255, 255],
    },

    {
      label: "TOTAL PAYMENTS",
      value: paymentTotal,
      x: 78,
      color: [255, 255, 255],
    },

    {
      label: "OUTSTANDING BALANCE",
      value: outstandingTotal,
      x: 128,
      color: GOLD,
    },

    {
      label: "CREDIT BALANCE",
      value: creditBalance,
      x: 176,
      color: [120, 255, 220],
    },
  ];

  kpis.forEach((kpi, i) => {

    if (i !== 0) {

      doc.setDrawColor(255);

      doc.setLineWidth(0.1);

      doc.line(
        kpi.x - 10,
        147,
        kpi.x - 10,
        165
      );
    }

    doc.setTextColor(255);

    doc.setFontSize(8);

    doc.text(
      kpi.label,
      kpi.x,
      152
    );

    doc.setTextColor(
      kpi.color[0],
      kpi.color[1],
      kpi.color[2]
    );

    doc.setFontSize(15);

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.text(
      `$${Number(
        kpi.value
      ).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        }
      )}`,
      kpi.x,
      161
    );
  });

  // =====================================================
  // ACTIVITY CARD
  // =====================================================

  doc.setFillColor(255);

  doc.roundedRect(
    14,
    178,
    188,
    88,
    8,
    8,
    "F"
  );

  // =====================================================
  // SECTION TITLE
  // =====================================================

  doc.setTextColor(
    PRIMARY[0],
    PRIMARY[1],
    PRIMARY[2]
  );

  doc.setFontSize(13);

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.text(
    "ACCOUNT ACTIVITY",
    20,
    194
  );

  // =====================================================
  // TABLE ROWS
  // =====================================================

  const invoiceRows =
    invoices.map((inv) => [

      new Date(
        inv.date_created
      ).toLocaleDateString(),

      "Invoice",

      inv.invoice_number,

      inv.item || "Invoice",

      `$${Number(
        inv.amount || 0
      ).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        }
      )}`,

      "-",

      `$${Number(
        inv.outstanding_amount ||
          inv.amount ||
          0
      ).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        }
      )}`,
    ]);

  const paymentRows =
    payments.map((p) => [

      new Date(
        p.payment_date
      ).toLocaleDateString(),

      "Payment",

      p.invoice_number,

      p.mode,

      "-",

      `$${Number(
        p.amount || 0
      ).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        }
      )}`,

      `$${Number(
        p.balance_outstanding ||
          0
      ).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        }
      )}`,
    ]);

  // =====================================================
  // TABLE
  // =====================================================

  autoTable(doc, {

    startY: 200,

    margin: {
      left: 18,
      right: 18,
    },

    head: [[
      "DATE",
      "TYPE",
      "REFERENCE",
      "DESCRIPTION",
      "INVOICE",
      "PAYMENT",
      "BALANCE",
    ]],

    body: [
      ...invoiceRows,
      ...paymentRows,
    ],

    styles: {

      fontSize: 8,

      cellPadding: 4,

      textColor: DARK,
    },

    headStyles: {

      fillColor: [230, 240, 240],

      textColor: PRIMARY,

      fontStyle: "bold",

      lineWidth: 0,
    },

    alternateRowStyles: {

      fillColor: [248, 250, 250],
    },

    bodyStyles: {

      lineWidth: 0.1,

      lineColor: [240, 240, 240],
    },
  });

  // =====================================================
  // SAVE
  // =====================================================

  doc.save(
    `${client.name}-statement.pdf`
  );
};

export default generateClientStatement;